<script lang="ts">
import Vue from 'vue'
import Checkbox from "@/components/ui/Checkbox.vue";
// import { updateTariff } from "@/api/tariff"
import TariffSetting from "@/views/insuranceProducts/components/TariffSetting.vue";
import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin"

export default Vue.extend({
    name: "PartnerList",
    components: {TariffSetting, Checkbox},
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        },
        companyName: {
            require: false,
            default() {
                return null
            }
        },
        productTypeId: {
            type: Number,
            require: false,
            default: null
        }
    },
    data() {
        return {
            visible: false,
        }
    },
    mixins: [tariffMixin],
})
</script>

<template>
<div class="partner-list">
    <div class="d-flex mb-2 cursor-pointer" @click="visible = !visible">
        Партнери
        <div class="ml-2">
            <svg :class="{ rotated: visible }" width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.02662 1.25411L7.57203 8.50684L14.1174 1.25411" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
    </div>
<!--    <div  class="w-50">-->
    <transition name="fade-slide">
        <div v-if="visible">
            <div class="row mb-2">
                <div class="col-2">Статус</div>
                <div class="col-5 col-md-6">Імʼя</div>
                <div class="col-4 col-md-2">Комісія/Знижка, %</div>
            </div>
            <div class="row" v-for="(item, index) in items" :key="item.id">
                <div class="col-2">
                    <Checkbox v-model="item.isActive" @change="updateTariff(item)" class="mr-2 mb-1"></Checkbox>
                </div>
                <div class="col-5 col-md-6">
                    {{ item.userFullName }}
                </div>
                <div class="col-4 col-md-2">
<!--                    {{$store.getters.USER_TYPES.find(user => user.key === 'landing').id}}test-->
<!--                    <div class="d-flex gap-4 vertical-center">-->
<!--                        <div v-if="item.userType === $store.getters.USER_TYPES.find(user => user.key === 'landing').id" class="commission">{{ item.commission || 0 }}</div>-->
                        <TariffSetting v-model="items[index]" :hide-discount="[8, 9, 10, 12].includes(productTypeId)">
                            Налаштування тарифів {{ companyName }} для точки продажу id: {{ item.userId }}
                        </TariffSetting>
<!--                        <div v-if="item.discount" class="discount">{{item.discount}}</div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </transition>
<!--    </div>-->
</div>
</template>

<style scoped>
.partner-list {
    /* Text xs / Semibold */
    font-family: 'Inter',serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    color: #000000;
    width: 60%;
    @media (max-width: 768px) {
        width:unset;
    }
    /* transition */
    .fade-slide-enter-active, .fade-slide-leave-active {
        transition: all 0.3s ease;
    }
    .fade-slide-enter, .fade-slide-leave-to {
        opacity: 0;
        transform: translateY(-5px);
    }

    svg {
        transition: transform 0.3s ease;
    }

    svg.rotated {
        transform: rotate(180deg);
    }
}
</style>
